export default function inkTonerFinderResultsPage(element) {
	if (element) {
		window.addEventListener('DOMContentLoaded', () => {
			window.setTimeout(() => {
				if (window.performance.navigation.type !== 1) {
					const scrollAmount = document
						.getElementById('inkTonerSwitcher')
						.getBoundingClientRect().bottom;
					window.scrollTo({
						top: scrollAmount,
						behavior: 'smooth',
					});
				}
			}, 100);
		});
	}
}
